export const validateEmail = (value) => {
  const emailRegexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailRegexp.test(value)
}

export const validatePassword = (password) => {
  // 8자 이상 20자 이하 체크
  if (!/^.{8,20}$/.test(password)) return false

  // 대문자, 소문자, 숫자, 특수문자 중 3가지 이상 포함 체크
  const typesMatched = [
    /[a-z]/,
    /[A-Z]/,
    /\d/,
    /[!@#$%^&*(),.?":{}|<>]/,
  ].filter((regex) => regex.test(password)).length
  if (typesMatched < 3) return false

  // 4자 이상의 반복되는 문자 체크
  if (/(.)\1{3,}/.test(password)) return false

  // 4자 이상의 연속된 숫자 또는 연속된 숫자 역순 체크
  if (
    /\d{4}/.test(password) &&
    /0123|1234|2345|3456|4567|5678|6789|7890|0987|9876|8765|7654|6543|5432|4321|3210/.test(
      password,
    )
  ) {
    return false
  }

  return true
}
